/**
 * @name vegas load async
 * @copyright by vegas s.
 * @date: 04.04.2020
 * @version  1.0
 *
 */

var $load = $('[data-load]');

$load.each(function () {
	let $self = $(this),
		method = $self.data('method') || false,
		breakpoint = $self.data('breakpoint') || false;
	
	if (method === 'ready') {
		$(document).ready(function () {
			setTimeout(() => {
				vegasLoadAsync.load($self);
			}, 100);
		});
	}
});

$(document).on('click', '[data-load]', function () {
	vegasLoadAsync.load($(this));
});

window.vegasLoadAsync = {
	load: ($self) => {
		var route = $self.data('load') || false,
			$target = $self.data('target') ? $($self.data('target')) : $self,
			preload = $self.data('preload') || false,
			loaded = !!$self.hasClass('loaded');

		if (!route) {
			return alert('Main parameters for loading are not specified')
		}

		if (loaded === false) {
			$self.addClass('loaded');

			if (preload) {
				$target.css('width', '100%').css('height', '100%');
				$target.html('<div class="vg-loader-preload fa-3x"><i class="fad fa-spinner-third fa-spin"></i></div>');
			}

			$.get(route, {}, function (data) {
				if (data.view) {
					if (preload) {
						$target.find('.vg-loader-preload').fadeOut();
					}
					
					$target.html(data.view).fadeIn();
				}
			});
		}
	},
	
	breakpoint: (point, width) => {
		if (point === 'sm' && width < 768) {
			return true;
		} else if (point === 'md' && width < 992) {
			return true;
		}

		return false;
	}
};